module.exports = __webpack_public_path__ + "media/images/flags/no-2018a70ba79c5d4022e4ab0e262b7b0c.svg";